import api from '../baseAPIs/shopify';
import { Settings } from '@extTypes/settings/settings';

export const getSettings = async (store: string): Promise<Settings.Settings> => {
    const response = await api.get('settings/private', {
        params: {
            shop: store
        }
    });
    return response.data;
};

export const getAppEmbedOnly = async (store: string): Promise<boolean> => {
    const response = await api.get<{ appEmbedOnly: boolean }>('settings/appEmbedOnly', {
        params: {
            shop: store
        }
    });
    return response.data.appEmbedOnly;
};

export const saveSettings = async (settings: Settings.Settings, shop: string, versioning = true) => {
    const response = await api.post('settings', settings, {
        params: {
            shop,
            versioning
        }
    });
    return response.data;
};

export const isEmailConfirmed = async (store: string): Promise<{ confirmed: boolean }> => {
    const response = await api.post('settings/email/check', null, {
        params: {
            shop: store
        }
    });
    return response.data;
};

export const sendAmazonTestMessage = async (
    store: string,
    payload: {
        deliveryMethod: 'attachment' | 'body';
        body: string;
        itemCount: number;
        messageType?: 'personalization' | 'submission';
    }
): Promise<{ sent: boolean; recipient?: string; error?: string }> => {
    const response = await api.post('settings/amazon/test-message', payload, {
        params: {
            shop: store
        }
    });
    return response.data;
};

export const hasTooltipType = async (
    type: Settings.TooltipType,
    operation: 'any' | 'all' = 'any'
): Promise<{ matches: boolean }> => {
    const response = await api.get('settings/tooltipType', {
        params: {
            type: type,
            operation: operation
        }
    });
    return response.data;
};
